import styles from "../pages/ChatScreen/Response/ResponseMessage.module.css";

export const preprocessContent = (content) => {
  if (!content || typeof content !== "string") return content;

  const htmlEntities = {
    "&lt;": "<",
    "&gt;": ">",
    "&amp;": "&",
  };

  // Step 1: Decode HTML entities
  let processedContent = content.replace(
    /(&lt;|&gt;|&amp;)/g,
    (match) => htmlEntities[match] || match
  );

  // Step 2: Remove empty think tags
  processedContent = processedContent.replace(
    /<think>\s*<\/think>|<think>\s*<think>/g,
    ""
  );

  // Step 3: Handle consecutive think tags by removing the inner one
  processedContent = processedContent.replace(
    /<think>(\s*)<think>/g,
    "<think>"
  );
  // Step 4: Handle complete think tags
  processedContent = processedContent.replace(
    /<think>([\s\S]*?)<\/think>/g,
    (_, content) => {
      if (!content || !content.trim()) return "";

      return `<div class="${styles.thinkContainer}" data-think-container>
        <div class="${styles.thinkHeader}" data-think-toggle>
          <span class="${styles.thinkIcon}">➤</span>
          <span>Thought process...</span>
        </div>
        <div class="${styles.thinkContent}">
          ${content
            .split(/(\b)/)
            .map((word) =>
              word.trim() ? `<i class="${styles.underline}">${word}</i>` : word
            )
            .join("")}
        </div>
      </div>`;
    }
  );

  // Step 5: Handle incomplete think tags
  processedContent = processedContent.replace(
    /<think>([\s\S]*?)$/g,
    (match, content) => {
      if (!content || !content.trim()) return "";

      return `<div class="${styles.thinkContainer}" data-think-container>
        <div class="${styles.thinkHeader}" data-think-toggle>
          <span class="${styles.thinkIcon}">➤</span>
          <span>Thought process...</span>
        </div>
        <div class="${styles.thinkContent}">
          ${content
            .split(/(\b)/)
            .map((word) =>
              word.trim() ? `<i class="${styles.underline}">${word}</i>` : word
            )
            .join("")}
        </div>
      </div>`;
    }
  );

  // Step 6: Handle single backticks (`content`) as italic
  processedContent = processedContent.replace(
    /(?<!`)`([^`]+)`(?!`)/g,
    (_, p1) => `<i>${p1}</i>`
  );

  // Step 7: Handle *single asterisks* (*content*) as bold
  processedContent = processedContent.replace(
    /(?<!\*)\*([^*]+)\*(?!\*)/g,
    (_, p1) => `<span class="${styles.light}">${p1}</span>`
  );

  // Step 8: Handle **double asterisks** (**content**) as bold
  processedContent = processedContent.replace(
    /\*\*([^*]+)\*\*/g,
    (_, p1) => `<b>${p1}</b>`
  );

  // Step 9: Handle *content (if missing a closing *) as bold
  processedContent = processedContent.replace(
    /\*([^*\n]+)$/gm,
    (_, p1) => `<span class="${styles.light}">${p1}</span>`
  );

  // Step 10: Handle newlines by replacing them with <br>
  // processedContent = processedContent.replace(/\n/g, "<br>");
  // Step 11: Handle numbered lists (e.g., 1., 2.)
  processedContent = processedContent.replace(
    /(\d+\.)(\s+)/g,
    (_, number, space) =>
      `<span class="${styles.numberList}">${number}</span>${space}`
  );
  processedContent = processedContent.replace(
    /(?<!`)`([^`]+)`(?!`)/g,
    (_, p1) => `<i>${p1}</i>`
  );
  return processedContent;
};
